import { useState, useEffect, useRef } from 'react';
import { Progress } from 'antd';

const FileProcess = ({ status }) => {
    const [currentProcess, setCurrentProcess] = useState(0);
    const [currentStatus, setCurrentStatus] = useState(status);
    const timerRef = useRef(null);

    useEffect(() => {
        setCurrentStatus(status);

        if (status === 'uploading') {
            // 启动定时器，每秒增加5%进度
            timerRef.current = setInterval(() => {
                setCurrentProcess(prevProcess => {
                    const newProcess = Math.min(prevProcess + 1, 100);

                    // 当进度达到90%时，更新状态为成功并清除定时器
                    if (newProcess >= 95) {
                        clearInterval(timerRef.current);
                        return 95;
                    }

                    return newProcess;
                });
            }, 100);
        } else if (timerRef.current) {
            // 如果状态不再是 uploading，清除定时器
            clearInterval(timerRef.current);
        }

        // 清理函数
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [status]);
    if (status === 'uploading') {
        return <Progress percent={currentProcess} showInfo={false} />
    }
    return null
}

export default FileProcess